module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_cxzero-e3d8e49e81a3c98a30655b4b88484fc2.svg";